import { ConcreteStep, Step } from '../../../../shared/domain/flows/types.no-deps'

export function isConcreteStep(step: Step): step is ConcreteStep {
    return !step.type || step.type === 'concrete'
}
